import { Link } from 'react-router-dom';
import { Clock, Mail, MapPin, Phone } from 'lucide-react';
import { MAIN_PHONE_DISPLAY, MAIN_PHONE_TEL } from '../../constants/contact';
import { pageMeta } from '../../constants/pageMeta';
import {
  ADDRESS_COUNTRY,
  ADDRESS_LINE1,
  ADDRESS_LINE2,
  CALL_NOTE,
  COMPANY_EMAIL,
  COMPANY_NAME,
  SITE_NAME,
  SUPPORT_HOURS,
} from '../../constants/site';
import PolicyPage, { Section } from '../components/PolicyPage';

const META = pageMeta(
  'Contact Us',
  `Contact ${SITE_NAME} (${COMPANY_NAME}) by phone at ${MAIN_PHONE_DISPLAY}, by email or by post.`,
  '/contact-us'
);

export default function ContactPage() {
  return (
    <PolicyPage
      title="Contact Us"
      meta={META}
      showUpdated={false}
      intro="Questions about a new trip or an existing booking? Reach the FlyNodex team any of these ways."
    >
      <div className="fx-contact">
        <a href={`tel:${MAIN_PHONE_TEL}`} className="fx-contact__card">
          <Phone size={22} aria-hidden />
          <span>
            <small>Phone</small>
            <strong>{MAIN_PHONE_DISPLAY}</strong>
          </span>
        </a>
        <a href={`mailto:${COMPANY_EMAIL}`} className="fx-contact__card">
          <Mail size={22} aria-hidden />
          <span>
            <small>Email</small>
            <strong>{COMPANY_EMAIL}</strong>
          </span>
        </a>
        <div className="fx-contact__card">
          <Clock size={22} aria-hidden />
          <span>
            <small>Phone hours</small>
            <strong>{SUPPORT_HOURS}</strong>
          </span>
        </div>
        <div className="fx-contact__card">
          <MapPin size={22} aria-hidden />
          <span>
            <small>Mailing address</small>
            <strong>
              {COMPANY_NAME}
              <br />
              {ADDRESS_LINE1}, {ADDRESS_LINE2}, {ADDRESS_COUNTRY}
            </strong>
          </span>
        </div>
      </div>

      <Section title="Before you call">
        <p>{CALL_NOTE}</p>
        <p>
          If you already have a booking with us, please have your {SITE_NAME} confirmation number, the travellers’
          names and your travel dates ready. If you booked directly with an airline, hotel or cruise line, that provider
          is usually best placed to help with your booking.
        </p>
      </Section>

      <Section title="Email replies">
        <p>We aim to answer emails within one business day. For anything urgent within 72 hours of travel, please call.</p>
      </Section>

      <Section title="Complaints">
        <p>
          If something has gone wrong, email <a href={`mailto:${COMPANY_EMAIL}`}>{COMPANY_EMAIL}</a> with “Complaint” in
          the subject line and your booking reference. We will acknowledge it within two business days and aim to
          resolve it within 14 days. See also our <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>.
        </p>
      </Section>
    </PolicyPage>
  );
}
